"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _AnimatedEllipsis = _interopRequireDefault(require("../AnimatedEllipsis/AnimatedEllipsis"));

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _hooks = require("../../hooks");

var _Drawer = require("./Drawer.styles");

var Mask = (0, _base["default"])("div", {
  target: "ezdw9lr0",
  label: "Mask"
})(_Drawer.mask, ";");

var Drawer = function Drawer(_ref) {
  var size = _ref.size,
      children = _ref.children,
      className = _ref.className,
      footer = _ref.footer,
      title = _ref.title,
      open = _ref.open,
      onClose = _ref.onClose,
      destroyOnClose = _ref.destroyOnClose,
      onHide = _ref.onHide,
      isLoading = _ref.isLoading,
      loadingProgress = _ref.loadingProgress,
      isError = _ref.isError,
      isNoResultFound = _ref.isNoResultFound,
      Container = _ref.container;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isLongLoading = _useState4[0],
      setIsLongLoading = _useState4[1];

  var forceUpdate = (0, _hooks.useForceUpdate)();
  var destroyClose = (0, _react.useRef)(null);
  var isDestroyOnClose = destroyOnClose && !visible;
  var isPreLoadedState = isLoading || isError || isNoResultFound;
  var loadingTimerRef = (0, _react.useRef)();

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      loadingComplete = _useState6[0],
      setLoadingComplete = _useState6[1]; // Clear the timer of tracking whether is long loading


  var clearTimer = (0, _react.useCallback)(function () {
    clearTimeout(loadingTimerRef.current);
    loadingTimerRef.current = null;
    setIsLongLoading(false);
  }, []);
  (0, _react.useEffect)(function () {
    // Make drawer have transition effect when the default state is open
    setVisible(open);

    if (!open) {
      clearTimer();
    }
  }, [clearTimer, open]);
  (0, _react.useEffect)(function () {
    if (visible && isLoading) {
      // After 0.75 seconds, show loading text too
      loadingTimerRef.current = setTimeout(function () {
        setIsLongLoading(true);
      }, 750);
    }

    return clearTimer;
  }, [clearTimer, isLoading, visible]);
  (0, _react.useEffect)(function () {
    if (loadingProgress >= 100) {
      clearTimeout(loadingTimerRef.current);
      loadingTimerRef.current = null;
    }
  }, [clearTimer, loadingProgress]);
  (0, _react.useEffect)(function () {
    if (isLoading) {
      setLoadingComplete(false);
    }
  }, [isLoading]);
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]); // If isDestroyOnClose is true and is not visible
  // set destroyClose.current to true and remove child components on rerender

  var onDestroyTransitionEnd = (0, _react.useCallback)(function () {
    if (!visible) {
      onHide();
    }

    if (!isDestroyOnClose) {
      return;
    }

    if (!visible) {
      destroyClose.current = true;
      forceUpdate();
    }
  }, [isDestroyOnClose, forceUpdate, visible, onHide]);
  var handleLoadingProgressEnd = (0, _react.useCallback)(function () {
    setLoadingComplete(!isLoading);
  }, [isLoading]); // Put progresss Bar outside of the loadingState:
  // It can finish the last transition and without delaying showing content

  var progressBar = (0, _jsxRuntime.jsx)("div", {
    css: _Drawer.styles.loadingBar,
    style: {
      transform: "scaleX(".concat(loadingProgress / 100, ")")
    },
    onTransitionEnd: handleLoadingProgressEnd
  });
  var loadingState = (0, _jsxRuntime.jsxs)("div", {
    className: "grui text-center",
    css: [_Drawer.styles.loadingText, isLongLoading && _Drawer.styles.showText, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
    children: [(0, _jsxRuntime.jsx)("p", {
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textNormal, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
      className: "grui",
      children: "Just a moment"
    }), (0, _jsxRuntime.jsxs)("p", {
      css: _elements.paragraph.styles.preflight,
      className: "grui",
      children: ["Grabbing the data from the backend", (0, _jsxRuntime.jsx)(_AnimatedEllipsis["default"], {})]
    })]
  });

  var renderBody = function renderBody() {
    if (destroyClose.current && !visible) {
      return null;
    }

    destroyClose.current = false;
    return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsxs)("div", {
        css: _Drawer.styles.header,
        children: [(0, _jsxRuntime.jsx)("h4", {
          css: _elements.heading.styles.h4,
          className: "grui",
          children: title
        }), (0, _jsxRuntime.jsx)("button", {
          className: "grui",
          css: _elements.button.styles.preflight,
          type: "button",
          onClick: handleClose,
          children: (0, _jsxRuntime.jsx)(_icons.Close, {
            className: "grui block"
          })
        })]
      }), (0, _jsxRuntime.jsxs)("div", {
        css: [_Drawer.styles.main, isPreLoadedState && _Drawer.styles.preLoadedState, process.env.NODE_ENV === "production" ? "" : ";label:renderBody;"],
        children: [!!loadingProgress && !isError && !loadingComplete && progressBar, isError && 'An error has occurred...', isLoading && !isError && loadingState, isNoResultFound && !isError && !isLoading && 'No results found...', !isPreLoadedState && children]
      }), footer]
    });
  };

  return (0, _jsxRuntime.jsxs)(Container, {
    css: [_Drawer.styles.base, visible && _Drawer.styles.visibleStyles, process.env.NODE_ENV === "production" ? "" : ";label:Drawer;"],
    onTransitionEnd: onDestroyTransitionEnd,
    children: [(0, _jsxRuntime.jsx)(Mask, {
      onClick: handleClose,
      visible: visible
    }), (0, _jsxRuntime.jsx)("div", {
      css: _Drawer.styles[size],
      className: className,
      children: renderBody()
    })]
  });
};

Drawer.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,

  /**
   * Narrow: 440px; wide: 740px
   */
  size: (0, _propTypes.oneOf)(['narrow', 'wide']),
  className: _propTypes.string,
  footer: _propTypes.node.isRequired,
  title: _propTypes.string.isRequired,

  /**
   * If the drawer is open or not
   */
  open: _propTypes.bool,

  /**
   * Handle close drawer
   */
  onClose: _propTypes.func.isRequired,

  /**
   * Whether to unmount child components on closing drawer
   */
  destroyOnClose: _propTypes.bool,

  /**
   * Handle when the drawer changes from visible to invisible
   */
  onHide: _propTypes.func,

  /**
   * Whether the content (children) is in a loading state
   * children components will not be rendered if true
   */
  isLoading: _propTypes.bool,

  /**
   * Loading progress: 0 to 100
   */
  loadingProgress: _propTypes.number,

  /**
   * Whether the content (children) has an error
   * children components will not be rendered if true
   */
  isError: _propTypes.bool,

  /**
   * Whether the content (children) has an empty state (for example if a resource could not be found)
   * children components will not be rendered if true
   */
  isNoResultFound: _propTypes.bool,

  /**
   * The drawer body container
   */
  container: _propTypes.node
};
Drawer.defaultProps = {
  size: 'narrow',
  className: undefined,
  open: undefined,
  destroyOnClose: false,
  onHide: function onHide() {},
  isLoading: false,
  loadingProgress: undefined,
  isError: false,
  isNoResultFound: false,
  container: 'div'
};
var _default = Drawer;
exports["default"] = _default;
//# sourceMappingURL=Drawer.js.map